/* global gapi */
const renderCharts = require('../charts/chartsRender');

function transformDataAndGenerateChart () {
  const chartsToRender = $('.part.ga-chart:not(.rendered)');
  chartsToRender
    .each(function (index, partElm) {
      var $part = $(partElm);
      const query = $part.data('query');
      const labels = $part.data('labels');
      const accessToken = $part.data('access');
      const name = $part.data('name');
      return requestGaData(query, accessToken, name, labels);
    });
}
function requestGaData (query, accessToken, name, labels) {
  labels = labels.length === 0 ? ['Visitors', 'New Visitors'] : labels;
  gapi.analytics.ready(function () {
    gapi.analytics.auth.authorize({
      serverAuth: {
        access_token: accessToken
      }
    });
    const report = new gapi.analytics.report.Data({ query });
    report.on('success', function (response) {
      function gaDateToTimestamp (gaDate) {
        const year = gaDate.substring(0, 4);
        const month = gaDate.substring(4, 6);
        const day = gaDate.substring(6, 8) || '01';
        return Date.parse(`${year}-${month}-${day}T00:00:00.000+00:00`);
      }
      function sortResBySource (response, maxResults = 5) {
        const sortByFirstArrayValue = (a, b) => a[0] - b[0];
        const bySource = response.rows
          .reduce((acc, [date, source, visitors]) => {
            if (acc[source] === undefined) {
              acc[source] = [];
            }
            acc[source].push([gaDateToTimestamp(date), Number(visitors)]);
            return acc;
          }, {});
        const graphFormat = Object.entries(bySource)
          .slice(0, maxResults)
          .map(([source, data]) => ({ name: source, data: data.sort(sortByFirstArrayValue).slice(1, -1) }));
        return graphFormat;
      }
      function prepareForGeoMap (data) {
        const maxCountriesToDisplay = 25;
        const geoData = response.rows
          .slice(0, maxCountriesToDisplay)
          .reduce((acc, [countryIsoCode, visitors]) => {
            acc[countryIsoCode.toLowerCase()] = Number(visitors);
            return acc;
          }, {});
        return geoData;
      }

      const dimensions = response.columnHeaders.filter(v => v.columnType === 'DIMENSION');
      const graph = document.getElementsByClassName(`ga-graph-${name}`)[0];
      const graphType = graph.getAttribute('data-type');
      let graphData = [];

      if (graphType === 'geo') {
        graphData = prepareForGeoMap(response);
      } else if (dimensions.length === 1) {
        const visitorsData = response.rows.map(([date, visitors, newVisitors]) => ([gaDateToTimestamp(date), Math.round(Number(visitors) * 100) / 100]));
        const newVisitorsData = response.rows.map(([date, visitors, newVisitors]) => ([gaDateToTimestamp(date), Math.round(Number(newVisitors) * 100) / 100]));
        graphData = [
          { name: labels[0], data: visitorsData.slice(1, -1) },
          { name: labels[1], data: newVisitorsData.slice(1, -1) }
        ]
          .filter(v => v.name !== undefined);
      } else {
        graphData = sortResBySource(response);
      }
      graph.children[0].innerHTML = JSON.stringify(graphData);
      graph.classList.add('chart');
      renderCharts();
    });
    report.execute();
  });
}

module.exports = transformDataAndGenerateChart;
